import TYPES from '../../types';

// Domain
import { CountryEntity } from '../../domain/entities/country-entity';
import { CountryRepository } from '../../domain/repository/country-repository';
import { StateManager } from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class SearchCountriesQuery extends Query<Promise<Array<CountryEntity>>> {
  @Inject(TYPES.CATALOG_ALLIANZ_COUNTRY_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.CATALOG_ALLIANZ_COUNTRY_REPOSITORY)
  private readonly repository!: CountryRepository;

  internalExecute(): Promise<Array<CountryEntity>> {
    return new Promise((resolve, reject) => {
      if (!this.state_manager.state.loaded) {
        this.repository.findAll()
          .then((items) => {
            this.state_manager.patch({ items });
            resolve(items);
          })
          .catch(reject);
      } else {
        resolve(this.state_manager.state.items);
      }
    });
  }
}
